import { cn } from '@ui/lib/utils'

interface FormMessageProps extends React.HTMLAttributes<HTMLParagraphElement> {
  message?: string
}

export function FormMessage({ message, className, ...props }: FormMessageProps) {
  if (!message) return null

  return (
    <p className={cn('text-sm text-gray-500', className)} {...props}>
      {message}
    </p>
  )
}
